import commonStyle from "./common.module.css";
import textStyle from "./text.module.css";


export default function Text(props) {

    const label = props['label']
    const id = props['id']
    const name = props['name']
    const max = props['max']
    const required = props['required']
    const disabled = props['disabled']
    const read = props['read']
    const value = props['value']
    const placeholder = props['placeholder']
    const event = props['event']
    const attributes = props['attributes']
    const error = props['error']

    return(
		<div className={commonStyle['wrap']}>
			{label &&
                <label
                    className={required === true ? commonStyle['required'] : null}
                >{label}</label>
            }

			<div className={commonStyle['field']}>
				<input
					type="text"
                    category="field"
					className={textStyle['text']}
					id={id}
					name={name}
					maxLength={max ? max : null}
					required={required === true ? true : false}
					disabled={disabled}
					readOnly={read}
					value={value}
					placeholder={placeholder}
                    error={error}
					{...event}
					{...attributes}
				></input>
			</div>

			{error &&
                <div className={commonStyle['error']}>{error}</div>
            }
		</div>
	);
}
